import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { CaseService } from 'src/app/services/case.service';

@Component({
  selector: 'app-case-preview',
  templateUrl: './case-preview.component.html',
  styleUrls: ['./case-preview.component.css']
})
export class CasePreviewComponent implements OnInit {

  caseData$: Observable<any>;

  constructor(
    private caseService: CaseService
  ) { }

  ngOnInit() {
    this.caseData$ = this.caseService.getCaseData();

  }

  getCaseServiceNames(caseServices: { id :number, name: string }[]): string {
    return caseServices?.length
      ? caseServices.map(service => service.name).join(', ')
      : '';
  }

}
